module.exports = __webpack_public_path__ + "ui-static/img/cards-no-items_light.c3b1d993.svg";